export class Scene3DShaderDeclaration {
}
